import fosInit from 'fosjsrouting-wrapper'

const initRouting = (base_url) => {
    const router = {
        ...require('../fos-routes'),
        base_url
    };

    const Routing = fosInit(router);
    const generate = function generate(route, routeParams, absolutPath = false)
    {
        return Routing.generate(route, routeParams, absolutPath);
    };
    const getBaseUrl = function getBaseUrl()
    {
        return Routing.getBaseUrl();
    };
    const getTranslationPath = function getTranslationPath({domain, locale, assetVersion=''})
    {
        if (_.isEmpty(locale)){
            locale='fr';
        }

        let url = Routing.getBaseUrl();
        url+=`/translations/${domain}.json?locales=${locale},en,&${assetVersion}`;

        return url;
    };

    return Object.assign({}, Routing, { generate, getBaseUrl, getTranslationPath });
};


export default initRouting;
